<template>
  <div>
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
    >
    <template slot="left" >
      <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
        <h1><v-icon large>mdi-tools</v-icon>{{$t('profile.tool.toolheadssub')}}</h1>
      </v-toolbar-title>
    </template>
  </Toolbar>
    <ToolHeadSubForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ToolHeadSubForm from '../../components/toolheadsub/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';

const servicePrefix = 'ToolHeadSub';
const routeAfterDel = 'ToolHeadUpdate';
const routeAfterDelId = 'toolHead';

export default {
  name: 'ToolHeadSubUpdate',
  servicePrefix,
  routeAfterDel,
  routeAfterDelId,
  mixins: [UpdateMixin],
  components: {
    Loading,
    Toolbar,
    ToolHeadSubForm
  },

  computed: {
    ...mapFields('toolheadsub', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('toolheadsub', ['find'])

  },

  methods: {
    ...mapActions('toolheadsub', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })

  }
};
</script>
